import BaseNode from './BaseNode';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { colors } from '../../styles';

const ErrorNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Erro" accent={colors.status.rejected} icon={<ErrorOutlineIcon />} />
);

export default ErrorNode;
